import { render, staticRenderFns } from "./CloseEmbeddedModal.vue?vue&type=template&id=52439f66&scoped=true&"
import script from "./CloseEmbeddedModal.vue?vue&type=script&lang=js&"
export * from "./CloseEmbeddedModal.vue?vue&type=script&lang=js&"
import style0 from "./CloseEmbeddedModal.vue?vue&type=style&index=0&id=52439f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52439f66",
  null
  
)

export default component.exports